import React from "react";
import { ArrowUpRight, Bookmark } from "lucide-react";
import PinItButton, { absoluteUrl } from "./PinItButton";

export default function ProductCard({ product }) {
  const pageUrl = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="group relative flex flex-col break-inside-avoid mb-4 sm:mb-6 bg-white border border-[#E6E1D6] gc-card gc-fade"
    >
      <div className="relative overflow-hidden w-full bg-[#F4F1EA]">
        <img
          src={absoluteUrl(product.image_url)}
          alt={product.name}
          loading="lazy"
          className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-[1.04] gc-sunwash"
        />
        {product.best_of_week && (
          <span
            data-testid={`badge-best-${product.id}`}
            className="absolute top-3 left-3 bg-[#EBAA86] text-[#2D3032] text-[10px] uppercase tracking-[0.18em] font-semibold px-2 py-1"
          >
            Best of the Week
          </span>
        )}
        {/* Pin-it hover */}
        <div className="absolute top-3 right-3 flex flex-col gap-2 opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-300">
          <PinItButton
            pageUrl={pageUrl}
            mediaUrl={`${process.env.REACT_APP_BACKEND_URL}/api/share/product/${product.id}.jpg`}
            description={`${product.name} — ${product.description}`}
            testid={`pin-product-${product.id}`}
          />
          <button
            aria-label="Bookmark"
            data-testid={`save-pinterest-${product.id}`}
            className="self-end bg-white/95 backdrop-blur text-[#2D3032] p-2 hover:bg-[#2D3032] hover:text-white transition-colors"
          >
            <Bookmark size={14} strokeWidth={1.8} />
          </button>
        </div>
      </div>
      <div className="p-4 sm:p-5 flex flex-col gap-2">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-heading text-base sm:text-lg font-medium text-[#2D3032] leading-tight">
            {product.name}
          </h3>
          {product.price && (
            <span className="text-sm text-[#8EAD9E] font-medium whitespace-nowrap">{product.price}</span>
          )}
        </div>
        <p className="text-sm text-[#636769] leading-relaxed">{product.description}</p>
        <a
          href={product.affiliate_url}
          target="_blank"
          rel="noopener noreferrer sponsored"
          data-testid={`view-product-${product.id}`}
          className="mt-3 w-full bg-[#2D3032] text-white py-2.5 text-xs uppercase tracking-[0.2em] font-medium hover:bg-[#8EAD9E] active:scale-[0.98] transition-all duration-200 flex justify-center items-center gap-2"
        >
          View Product
          <ArrowUpRight size={14} strokeWidth={1.8} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </article>
  );
}
